module.exports = __webpack_public_path__ + "img/back-stage.eebc0f83.png";